import { IPerformanceTableDataCampaign } from "@components/OrganicSales/OrganicTable";
import { Api } from "src/utils/api";
import { KEYWORDS_API_BASE_URL } from "./keywords.constant";

export interface BaseRequestParams {
  date_start: string;
  date_end: string;
  saturation?: number;
  sort_field?: string;
  sort_direction?: "asc" | "desc";
  filter_keyword?: string;
}

export class KeywordApi extends Api {
  constructor() {
    super(KEYWORDS_API_BASE_URL);
  }

  private async makeRequest<T>(
    endpoint: string,
    params: BaseRequestParams & { asins?: string[]; brands?: string[] },
    isGetRequest = false,
  ): Promise<T> {
    const {
      date_start,
      date_end,
      saturation,
      sort_field,
      sort_direction,
      filter_keyword,
      asins,
      brands,
      ...extra
    } = params;

    const body: Record<string, any> = {
      date_start,
      date_end,
      ...(saturation !== undefined && { saturation }),
      ...(sort_field !== undefined && { sort_field }),
      ...(sort_direction !== undefined && { sort_direction }),
      ...(filter_keyword !== undefined && { filter_keyword }),
      ...extra,
    };

    if (Object.prototype.hasOwnProperty.call(params, "asins")) {
      body.asins = asins!;
    }
    if (Object.prototype.hasOwnProperty.call(params, "brands")) {
      body.brands = brands!;
    }

    return isGetRequest
      ? this.get<T>(endpoint, body)
      : this.post<T>(endpoint, body);
  }

  public getKeywordPerfomanceBrand(
    date_start: string,
    date_end: string,
    saturation: number,
    sort_field: string,
    sort_direction: "asc",
    filter_keyword = "",
    brands: string[] = [],
    offset: number = 0,
    limit: number = 8,
  ): Promise<IPerformanceTableDataCampaign[]> {
    return this.makeRequest("/keyword-performance/brand", {
      date_start,
      date_end,
      saturation,
      sort_field,
      sort_direction,
      filter_keyword,
      brands,
      offset,
      limit,
    });
  }

  public getKeywordPerfomanceAsin(
    date_start: string,
    date_end: string,
    saturation: number,
    sort_field: string,
    sort_direction: "asc",
    filter_keyword = "",
    asins: string[] = [],
    offset: number = 0,
    limit: number = 8,
  ): Promise<IPerformanceTableDataCampaign[]> {
    return this.makeRequest("/keyword-performance/asin", {
      date_start,
      date_end,
      saturation,
      sort_field,
      sort_direction,
      filter_keyword,
      asins,
      offset,
      limit,
    });
  }

  public getKeywordPerfomanceAsinSearchQuery(
    date_start: string,
    date_end: string,
    saturation: number,
    sort_field: string,
    sort_direction: "asc",
    filter_keyword = "",
    asins: string[] = [],
  ): Promise<IPerformanceTableDataCampaign[]> {
    return this.makeRequest("/keyword-performance/asin/search-query", {
      date_start,
      date_end,
      saturation,
      sort_field,
      sort_direction,
      filter_keyword,
      asins,
    });
  }

  public getKeywordPerfomanceBrandSearchQuery(
    date_start: string,
    date_end: string,
    saturation: number,
    sort_field: string,
    sort_direction: "asc",
    filter_keyword = "",
    brands: string[] = [],
  ): Promise<IPerformanceTableDataCampaign[]> {
    return this.makeRequest("/keyword-performance/brand/search-query", {
      date_start,
      date_end,
      saturation,
      sort_field,
      sort_direction,
      filter_keyword,
      brands,
    });
  }
}
